import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import Button from '../buttons'
// import "./header-view-v2.scss"
import AppLegacyButton from '../../../component/common/AppLegacyButton.tsx'

const HeaderActionsV2 = ({
  showBackButton,
  backButton,
  primaryButton,
  primaryButtonText,
  primaryButtonIcon,
  isDisabledPrimaryButton,
  secondaryButton,
  secondaryButtonText,
  isDisabledSecondaryButton,
  secondaryButtonIcon,
}) => {
  const { formatMessage: msg } = useIntl()
  const navigate = useNavigate()

  return (
    <>
      {
        /* Botton back */
        showBackButton && (
          <AppLegacyButton
            id="goback-button"
            icon="back"
            iconPosition="left"
            label={msg({ id: 'button.back' })}
            onClick={() => {
              if (backButton) {
                backButton()
              } else {
                navigate(-1)
              }
            }}
            color="primary"
            variant="outline"
            bg="bg-container"
          />
        )
      }
      {/* others bottons*/}
      {primaryButton && (
        <AppLegacyButton
          id="primary-button"
          icon={primaryButtonIcon}
          iconPosition="right"
          label={primaryButtonText ? msg({ id: primaryButtonText }) : ''}
          disabled={isDisabledPrimaryButton || false}
          onClick={() => secondaryButton()}
          color="white"
          bg="moure-blue"
        />
        // <Button
        //     id="primary-button"
        //     btnText={primaryButtonText ? msg({ id: primaryButtonText }) : ""}
        //     btnType="button"
        //     btnClass="btn__bg-dark-blue"
        //     isDisabled={isDisabledPrimaryButton}
        //     onHandleClick={() => primaryButton()}
        //     iconRight
        //     iconSize="1rem"
        //     iconClass={primaryButtonIcon}
        // />
      )}
      {secondaryButton && (
        <AppLegacyButton
          id="secondary-button"
          icon={secondaryButtonIcon}
          iconPosition="right"
          label={secondaryButtonText ? msg({ id: secondaryButtonText }) : ''}
          disabled={isDisabledSecondaryButton || false}
          onClick={() => secondaryButton()}
          color="white"
          bg="moure-orange"
        />
        // <Button
        //     id="secondary-button"
        //     btnText={secondaryButtonText ? msg({ id: secondaryButtonText}) : ""}
        //     btnType="button"
        //     btnClass="btn__bg-orange"
        //     isDisabled={isDisabledSecondaryButton || false}
        //     onHandleClick={() => secondaryButton()}
        //     iconRight
        //     iconSize="1rem"
        //     iconClass={secondaryButtonIcon}
        // />
      )}
    </>
  )
}

export default HeaderActionsV2
